module.exports = __webpack_public_path__ + "static/img/box-3.776d117.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/box-3.png
// module id = gQb8
// module chunks = 1